import { enableInProductionOrUseLocalOverride } from './util/enable-in-production-or-use-local-override';

// We want this flag to be "true" in production, false
// locally in dev, and also false locally when running the
// app in production asset testing mode locally
export const isProd = enableInProductionOrUseLocalOverride('REACT_APP_IS_PROD_LOCAL_OVERRIDE');

export const IMAGE_PATH = isProd
  ? 'https://images.expeditiondata.com'
  : 'https://images-dev.thehiringengine.com';

export const DOMAIN = isProd
  ? 'https://employer.teamengine.io'
  : 'https://local.employer.expeditiondata.com:8443';

export const APPLICATION_DOMAIN = isProd
  ? 'https://apply.teamengine.io'
  : 'https://local.apply.expeditiondata.com:3000';

export const CAREERS_DOMAIN = isProd ? 'https://jobs.teamengine.io' : 'http://localhost:8080';

export const EMBEDDABLE_CAREERS_DOMAIN = isProd
  ? 'https://embed.teamengine.io/v0.2'
  : 'http://localhost:6464';

export const STRIPE_PUBLIC_KEY = isProd
  ? 'pk_live_qJvwyN0QCbD7hDEfcfbBNgLL'
  : 'pk_test_p1M7Ydyl8ESfrDlaB1Lx6KBs';

export const STRIPE_WEBSITE_URL = isProd
  ? 'https://dashboard.stripe.com'
  : 'https://dashboard.stripe.com/test';

export const SALESFORCE_ACCOUNT_BASE_URL = isProd
  ? 'https://expeditiondata.lightning.force.com'
  : 'https://expeditiondata--devsbox2.sandbox.lightning.force.com';
